'use strict';

const jsxRuntime = require('react/jsx-runtime');
const components_display_Badge_Badge = require('../../display/Badge/Badge.cjs.js');

function PageNavigationBadge(props) {
  return jsxRuntime.jsx("span", { "data-zds": true, children: jsxRuntime.jsx(components_display_Badge_Badge.Badge, Object.assign({}, props)) });
}

module.exports = PageNavigationBadge;
//# sourceMappingURL=PageNavigationBadge.cjs.js.map
